import { Stack, Text } from 'components';

import { useNoteFormContext } from '../../context/noteFormContext';
import { useIsTranscribing } from '../../hooks/useIsTranscribing';
import { AiScribeIcon } from '../../utils/helpers';
import style from '../../noteEdit.module.scss';

export const Status = () => {
  const { note } = useNoteFormContext();
  const isTranscribing = useIsTranscribing();

  // Show transcribing in progress status
  if (isTranscribing) {
    return (
      <Stack
        width="100%"
        mb="16px"
        className={style.aiScribeInProgress}
        gap="8px"
        display="flex"
        flexDirection="row"
        padding="12px"
        alignItems="center"
        boxSizing="border-box"
        borderRadius="8px"
      >
        <AiScribeIcon />
        <Text weight="medium" size="normal" className={style.aiScribeInProgressText}>
          AI Scribe is processing your note, you'll be able to edit when it's done. Check back soon!
        </Text>
      </Stack>
    );
  }

  // Show error status
  if (note?.aiScribe?.status === 'FAILED' && note?.aiScribe?.errorMessage) {
    return (
      <Stack
        width="100%"
        mb="16px"
        className={style.aiScribeError}
        gap="8px"
        display="flex"
        flexDirection="row"
        padding="12px"
        alignItems="center"
        boxSizing="border-box"
        borderRadius="8px"
      >
        <span className="material-icons">error_outline</span>
        <Text weight="medium" size="normal" className={style.aiScribeErrorText}>
          {note.aiScribe.errorMessage}
        </Text>
      </Stack>
    );
  }

  return null;
};
